import { lazy } from 'react';

import asyncComponent from '@components/asyncComponent';
import { componentLoader } from '@helpers/components';

const App = lazy(() => componentLoader(() => import(/* webpackChunkName: 'app' */ './App')));

export default asyncComponent(App, 'App');
